import * as React from "react";
import {
  DataGrid,
  GridColumns,
  GridRenderCellParams,
  GridRowsProp,
} from "@mui/x-data-grid";
import { Navigate, useNavigate } from "react-router-dom";

/* Localização */
/*
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
*/
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import br from "date-fns/locale/pt-BR";

/* Meus Componentes */
import { hasInCache } from "../../helper/cacheHelper";

/* Minhas Classes */
import Contrato from "../../components/classes/Contrato";
import ContratoDataset from "../../components/data/ContratoDataSet";

import PageHelper from "../../helper/pageHelper";

/* Componentes */
import Button from "@mui/material/Button";

import { confirmAlert } from "react-confirm-alert";

/* LOCALIZAÇÃO */

import { format } from "date-fns";
import { pt } from "date-fns/locale";

import styles from "./detail.module.css";
import { useTranslation } from "react-i18next";

interface props {
  data: Contrato | null;
}

interface Data {
  id: number;
  grupo: string;
  numeroContrato: string;
  // projeto: string;
  modalidade: string;
  inicioVigencia: string;
  fimVigencia: string;
  quantidade: number;
  consumo: number;
}

function ContratoGrid(param: props) {
  const { t } = useTranslation();
  const [loading, setLoading] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [contratos, setContratos] = React.useState<Contrato[]>([]);
  const dataContrato: ContratoDataset = new ContratoDataset();

  const [rows, setRows] = React.useState<Data[]>([]);
  const navigate = useNavigate();

  function createData(
    id: number,
    grupo: string,
    numeroContrato: string,
    modalidade: string,
    inicioVigencia: string,
    fimVigencia: string,
    quantidade: number,
    consumo: number
  ): Data {
    return {
      id,
      grupo,
      numeroContrato,
      modalidade,
      inicioVigencia,
      fimVigencia,
      quantidade,
      consumo,
    };
  }

  React.useEffect(() => {
    setLoading(true);
    let _codigoFornecedorSap: number = 0;
    if (hasInCache("CodigoFornecedorSAPSelecionado")) {
      _codigoFornecedorSap = Number.parseInt(
        String(localStorage.getItem("CodigoFornecedorSAPSelecionado"))
      );
      dataContrato
        .ListarAtivos(_codigoFornecedorSap)
        .then((result) => {
          if (result) {
            setContratos(result);
            setRows(
              result.map((_contrato: Contrato) => {
                return createData(
                  Number(_contrato.id),
                  String(_contrato.grupo),
                  String(_contrato.numeroContrato),
                  // String(_contrato.projeto),
                  String(_contrato.modalidadeFrete),
                  _contrato.inicioVigencia.toString().substring(10, 8) +
                    "/" +
                    _contrato.inicioVigencia.toString().substring(7, 5) +
                    "/" +
                    _contrato.inicioVigencia.toString().substring(0, 4),
                  _contrato.finalVigencia.toString().substring(10, 8) +
                    "/" +
                    _contrato.finalVigencia.toString().substring(7, 5) +
                    "/" +
                    _contrato.finalVigencia.toString().substring(0, 4),
                  Number(_contrato.itensContrato.length),
                  0
                );
              })
            );
          } else {
            setContratos([]);
            setRows([]);
          }
        })
        .catch((erro) => {
          Mensagem(
            "ERRO",
            "Não foi possível recuperar o dados! A aplicação apresentou o seguinte erro : " +
              erro
          );
          setLoading(false);
        });
    } else {
      Mensagem("AVISO", "É necessário selecionar um Parceiro!");
    }
    setLoading(false);
  }, []);

  function dateFormat(date: Date): string {
    return date.toLocaleDateString("pt-BR");
  }

  const columns: GridColumns = [
    {
      field: "id",
      headerName: "#",
      type: "string",
      width: 80,
      headerAlign: "center",
      align: "center",
      editable: false,
    },
    {
      field: "grupo",
      headerName: t("global.table.group"),
      type: "string",
      width: 130,
      headerAlign: "center",
      align: "center",
      editable: false,
    },
    {
      field: "numeroContrato",
      headerName: t("global.table.contractNumber"),
      type: "string",
      width: 200,
      headerAlign: "center",
      align: "center",
      editable: false,
    },
    {
      field: "modalidade",
      headerName: t("global.table.freight"),
      type: "string",
      width: 100,
      headerAlign: "center",
      align: "center",
      editable: false,
    },
    {
      field: "inicioVigencia",
      headerName: t("global.table.startVigency"),
      type: "date",
      width: 160,
      headerAlign: "center",
      align: "center",
      editable: false,
    },
    {
      field: "fimVigencia",
      headerName: t("global.table.endVigency"),
      type: "date",
      width: 160,
      headerAlign: "center",
      align: "center",
      editable: false,
    },
    {
      field: "quantidade",
      headerName: t("global.table.itemQuantity"),
      type: "date",
      width: 120,
      headerAlign: "center",
      align: "right",
      editable: false,
    },
    {
      field: "consumo",
      headerName: t("global.table.consumption"),
      type: "number",
      width: 110,
      headerAlign: "center",
      align: "right",
      editable: false,
    },
    {
      field: " ",
      sortable: false,
      renderCell: () => {
        return (
          <Button size="small" variant="contained" color="primary">
            <small>{t("global.table.seeDetails")}</small>
          </Button>
        );
      },
    },
  ];

  const Mensagem = (titulo: string, mensagem: string) => {
    return confirmAlert({
      title: titulo,
      message: mensagem,
      buttons: [
        {
          label: "Ok",
          onClick: () => {
            setOpen(false);
            PageHelper.refreshPage();
          },
        },
      ],
    });
  };

  const handleSelectionChange = (id: any) => {
    let _contrato: Contrato | null = null;
    if (contratos.filter((f) => f.id === Number(id)).length === 1) {
      _contrato = contratos.filter((f) => f.id === Number(id))[0];
      if (_contrato !== null) {
        dataContrato.AdicionarObjetoAoCache(_contrato);
        navigate("/contrato/detalhe");
      }
    }
  };

  return (
    <div className={`gridScroll ${styles.table}`}>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterlocale={br}>
        <DataGrid
          loading={loading}
          rows={rows}
          columns={columns}
          experimentalFeatures={{ newEditingApi: true }}
          onSelectionModelChange={(ids) => {
            handleSelectionChange(ids);
          }}
          key="ContratoGrid"
          rowHeight={35}
          rowsPerPageOptions={[50, 100, 250, 500]}
        />
      </LocalizationProvider>
    </div>
  );
}

export default ContratoGrid;
